// src/pages/NemtMrDashboard.js
import React, { useMemo } from 'react';
import DashboardTemplate from '../../GlobalLayouts/DashboardTemplate'; // Adjust the path as needed
import FilterableTable from '../../GlobalComponents/FilterableTable'; // Import the FilterableTable component
import testData from '../../TestData/tripTest.json'; // Import the data for the table
import mockTripData from '../../TestData/mockTripData.json'; // Import mock trip data for testing
import { Text, useColorModeValue } from '@chakra-ui/react';
import tableConfig from '../../TestData/tableconfig.json'; // Adjust the path if needed

const NemtMrDashboard = () => {
  // Define dynamic colors using useColorModeValue
  const tableTextColor = useColorModeValue('black', 'white'); // Adjust color as needed
  const dropdownBg = useColorModeValue('white', 'black'); // Background color for dropdowns
  const dropdownColor = useColorModeValue('black', 'white'); // Text color for dropdowns
  const cardBg = useColorModeValue('#EEF2E3', '#16A54A'); // Background color for cards
  const titleColor = useColorModeValue('rcBrand.forest', 'white'); // Title color
  const filterIconColor = useColorModeValue('#00853E', '#D5E14D'); // Filter icon color
  const filterDrawerBg = useColorModeValue('#EEF2E3', '#023F2E'); // Filter drawer background color
  const tableBgColor = useColorModeValue('white', 'black'); // Table background color
  const tableBorderColor = useColorModeValue('#cccccc', '#4A5568'); // Table border color
  const headerBgColor = useColorModeValue('#d3d3d3', '#2D3748'); // Header background color
  const headerHoverColor = useColorModeValue( '#EEF2E3',  '#023F2E'); // Header hover color
  const headerTextColor = useColorModeValue('black', 'white'); // Header text color
  const headerSelectedColor = useColorModeValue( '#EEF2E3','#023F2E'); // Header selected color
  const currentHeader = useColorModeValue('#D5E14D','#16A54A'); // Current header color
  const highlightcolumn = useColorModeValue('#D5E7ED','#023F2E'); // Highlighted column color
  const borderColor = useColorModeValue( "#EEF2E3", 'gray'); // Border color for columns
    // Sample data to pass to the modal
    const modalData = {
      card1Content: "This is some content for the first card",
      card2Content: "This is some content for the second card",
    };
  

  // Adjust the table configuration based on the current color mode
  const adjustedTableConfig = useMemo(() => {
    return {
      ...tableConfig,
      styles: {
        ...tableConfig.styles,
        bgCell: tableBgColor,
        textDark: tableTextColor,
        textHeader: tableTextColor,
        borderColor: tableBorderColor,
        bgHeader: tableBgColor,
        headerTextColor: headerTextColor,
        bgHeaderHovered: headerHoverColor,
        bgHeaderHasFocus: headerSelectedColor,
        accentColor: currentHeader,
        textHeaderSelected: tableTextColor,
        accentFg: currentHeader,
        accentLight: currentHeader,
        tableColor: tableBgColor,
        horizontalBorderColor: borderColor,

       
      },
      options: {
        ...tableConfig.options,
        rowMarkerTheme: { bgCell: tableBgColor, textDark: tableTextColor},
        highlightColors: { current: highlightcolumn,column: highlightcolumn, rows: highlightcolumn },
      }
    };
  }, [tableConfig, tableBgColor, tableTextColor, tableBorderColor, headerBgColor, headerHoverColor]);

  // Define the tabs for the left side
  const leftTabs = [
    {
      label: 'Dashboard',
      content: (
        <FilterableTable
          data={testData}
          config={adjustedTableConfig} // Pass the adjusted table configuration here
          tripsData={mockTripData} // Pass mock trip data for testing purposes
          modalData={modalData} // Pass the sample modal data here
          filterdropdownBg={dropdownBg}
          filterdropdownTextColor={dropdownColor}
          cardWidth="90%"
          cardHeight="800px"
          tableWidth="100%"
          tableHeight="600px"
          borderRadius="12px"
          boxShadow="0 8px 16px rgba(0, 0, 0, 0.2)"
          cardMarginBottom="40px"
          cardPadding="24px"
          headerHeight={55}
          rowHeight={60}
          isDraggable={true}
          textColor={tableTextColor}
          dropdownBg={dropdownBg}
          dropdownColor={dropdownColor}
          cardBg={cardBg}
          filterIconColor={filterIconColor}
          filterDrawerBg={filterDrawerBg}
        />
      ),
    },
    {
      label: 'Reports',
      content: <Text>This is content for the Reports Tab</Text>,
    },
  ];

  // Define the right content (you can update this as per your requirements)
  const rightContent = <Text>Will have filter things</Text>;

  return (
    <DashboardTemplate
      title="Ride to Care Trip Verification Dashboard"
      titleColor={titleColor}
      tabButtonSize="xl"
      tabButtonBg="#D5E14D"
      tabButtonTextColor="#023F2E"
      tabButtonBorderColor="#D5E14D"
      tabButtonHoverBg="#D5E14D"
      tabContentBg="gray.50"
      layoutTextColor="black"
      tabButtonFontWeight="bold"
      leftTabs={leftTabs}
      rightContent={rightContent}
    />
  );
};

export default NemtMrDashboard;
